import React, { useEffect, useState } from 'react';
import GroupForm from '../GroupForm/GroupForm';
import SearchPeople from '../SearchPeople';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tabs from '../global/Tabs/Tabs';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateGroupRequest,
  getGroupPrivacyTypesRequest,
  getGroupRequest,
  addGroupMemberRequest,
} from '../../actionCreators/groupActions';
import GridContainer from '../global/GridContainer/GridContainer';
import { useNavigate, useParams } from 'react-router-dom';
import { GroupApi, SearchApi } from '../../api';
import { searchPeopleRequest } from '../../actionCreators/search';

const ManageComponent = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const [state, setState] = useState({
    activeTab: 'Overview',
    showErrors: false,
    group: null,
  });

  useEffect(() => {
    const getGroupData = async () => {
      const d = await GroupApi.getGroup(params.groupId);
      const searchResults = await SearchApi.getPeople({groupId: params.groupId });
      setState({ ...state, group: d.group, searchResults: searchResults });
    };

    getGroupData();
  }, []);

  if (state && state.group) {
    const searchPeople = props.searchPeople;
    const token = props.currentUser.signInData;

    const tabs = [{ label: 'Overview' }, { label: 'Members' }];

    const _activateTab = (target) => {
      if (state.activeTab === target) return;

      setState({ ...state, activeTab: target, showErrors: false });
    };

    const renderContent = () => {
      return (
        <div>
          <div className="manage-group-header-back-link" onClick={() => navigate(-1)}>
            <FontAwesomeIcon
              icon={['fas', 'chevron-left']}
              className="feed-group-header-back-link-icon"
            />
            {'Go back'}
          </div>
          <div className="d-flex align-items-center">
            <div className="d-flex justify-content-end flex-wrap flex-fill">
              <div className="d-flex flex-column flex-fill">
                <span className="manage-group-header-title pb-2">Manage Group</span>
                <div className="d-flex flex-wrap align-items-center">
                  <>
                    <span className="manage-group-header-desc">{state?.group?.name ?? 'TEST'}</span>
                    <span className="manage-group-footer-splitter" />
                    <span className="manage-group-header-desc">
                      {' '}
                      {state?.group?.total_users} member{state?.group?.total_users > 1 ? 's' : ''}{' '}
                    </span>
                  </>
                </div>
                <div className={`create-feed-holder active`}>
                  <div className="d-flex flex-wrap align-items-center">
                    <Tabs
                      screen={'manageGroup'}
                      tabs={tabs}
                      onChange={_activateTab}
                      active={!state.activeTab}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    const { categories, groupPrivacyTypes, searchResults, groupsDetailedUpdatedAt } = props;
    return (
      <div className="manage">
        <GridContainer>
          <div className="d-flex w-100 flex-column">
            <div className="manage-group-header">
              <div className="manage-group-header-content">{renderContent()}</div>
            </div>
            <div className="manage-group-content manage-group-content__lower-margin">
              {state.activeTab === 'Overview' ? (
                <GroupForm
                  group={state.group}
                  getGroup={props.getGroup}
                  history={props.history}
                  categories={categories}
                  privacyTypes={groupPrivacyTypes}
                  updatedAt={groupsDetailedUpdatedAt}
                  updateGroup={props.updateGroup}
                  token={token}
                />
              ) : (
                <SearchPeople
                  group={state.group}
                  addMembers={props.addMembersToGroup}
                  token={token}
                  searchResults={state.searchResults}
                  searchPeople={searchPeople}
                />
              )}
            </div>
          </div>
        </GridContainer>
      </div>
    );
  } else {
    return <p>LOADING</p>;
  }
};

const Manage = (props) => {
  const state = useSelector((state) => ({
    ...state.group,
    currentUser: state.currentUser,
    groupPrivacyTypes: state.group.groupPrivacyTypes,
  }));

  const dispatch = useDispatch();

  const actions = {
    searchPeople: payload => dispatch(searchPeopleRequest(payload)),
    updateGroup: (payload) => dispatch(updateGroupRequest(payload)),
    getGroupPrivacyTypes: () => dispatch(getGroupPrivacyTypesRequest()),
    getGroup: (payload) => dispatch(getGroupRequest(payload)),
    addMembersToGroup: payload => dispatch(addGroupMemberRequest(payload)),
  };

  return <ManageComponent {...props} {...state} {...actions} />;
};

export default Manage;
